<template>
  <div class="img-wrapper flex flex-col items-center text-white">
    <h3 class="text-2xl">There is no inoice yet</h3>
    <h4 class="text-xl mb-4">Create a New invoice</h4>
    <img
      src="@/assets/illustration-empty.svg"
      alt="illustration for empty list"
    />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.img-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  img {
    margin: 0 auto;
  }
}
</style>
